import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";

class Tabs {
  constructor({
    parent = document.body,
    index = 0,
    el,
    onTabChange = () => {},
  }) {
    this.parent = el && el.parentNode ? el.parentNode : _$(parent).sel()[0];
    this.currentIndex = index;
    this.element = el;
    this.onTabChange = onTabChange;
    this.init();
  }

  init = () => {
    const tabs = this.element
      ? [this.element]
      : this.parent.querySelectorAll(".tabs");
    tabs.forEach((curTab) => {
      const links = curTab.querySelectorAll(".tabs a");
      const allTabs = curTab
        .closest(".tabs-container")
        .querySelectorAll(".tab-pane");
      const selectTab = (curLink, relTab, tabName) => {
        try {
          links.forEach((link) =>
            link.closest("li").classList.remove("is-active")
          );
          curLink.closest("li").classList.add("is-active");
          allTabs.forEach((tab) => tab.classList.remove("is-active"));
          relTab.classList.add("is-active");
          this.onTabChange(tabName);
        } catch (ex) {
          console.log(ex);
        }
      };
      try {
        links.forEach((curLink) => {
          const curTabsSection = curLink.closest(".tabs-container");
          const tabName = curLink.closest("li").getAttribute("rel");
          const relTab = curTabsSection.querySelector(
            ".tab-pane[name='" + tabName + "']"
          );
          if (relTab) relTab.classList.remove("is-active");
          const index = utils.elementIndex(curLink.parentNode);
          if (this.currentIndex === index) {
            selectTab(curLink, relTab, tabName);
          }
          _$(curLink).on("click", (e) => {
            if (!curLink.parentElement.classList.contains("is-active"))
              selectTab(curLink, relTab, tabName);
          });
        });
      } catch (ex) {
        console.log(ex);
      }
    });
  }

  setIndex = (index) => {
    if (this.element && utils.isNumeric(index)) {
      try {
        index += 1;
        const link = this.element.querySelector(
          "li[rel]:nth-child(" + index + ")"
        );
        if (link) {
          link.querySelector("a").click();
        }
      } catch (ex) {
        console.log(ex);
      }
    }
  }

  setTabByName = (name) => {
    if (this.element && name) {
      const link = this.element.querySelector("li[rel='" + name + "']");
      if (link) {
        link.querySelector("a").click();
      }
    }
  }

  getIndex = () => {
    if (this.element) {
      return utils.elementIndex(this.element.querySelector("li.is-active"));
    } else {
      return null;
    }
  }
}

export default Tabs;
